import Vue from 'vue'

import WCPageTitle from '@/components/misc/WCPageTitle'
import WCLoading from '@/components/misc/WCLoading'
import WCSectionTitle from '@/components/misc/WCSectionTitle'
import WCFullPageLoading from '@/components/misc/WCFullPageLoading'
import WCTwoColumnTable from '@/components/misc/WCTwoColumnTable';
import WCSaveCancelButtons from '@/components/misc/WCSaveCancelButtons'

// Pickers
import WCMenuDatePicker from '@/components/pickers/WCMenuDatePicker'
import WCMenuTimePicker from '@/components/pickers/WCMenuTimePicker'
import WCColorPicker from '@/components/pickers/WCColorPicker'

// Dialogs
import WCConfirmDialog from '@/components/dialogs/WCConfirmDialog'
import WCDialog from '@/components/dialogs/WCDialog'

// Chips
import WCContactRoleChips from '@/components/chips/WCContactRoleChips'

// Misc
import WCAvatar from '@/components/misc/WCAvatar'
import WCMiniCard from '@/components/misc/WCMiniCard'
import WCArchiveIcon from '@/components/misc/WCArchiveIcon'
import WCArchiveButton from '@/components/misc/WCArchiveButton'
import WCSnackbar from '@/components/misc/WCSnackbar'
import WCTableList from '@/components/misc/WCTableList'
import WCDataBox from '@/components/misc/WCDataBox'
import WCToolbarSearch from '@/components/misc/WCToolbarSearch'
import WCRatings from '@/components/misc/WCRatings'
import WCHelpDialog from '@/components/misc/WCHelpDialog'
import WCHelpToolbarIcon from '@/components/misc/WCHelpToolbarIcon'
import WCShowArchivedButton from '@/components/misc/WCShowArchivedButton'
import WCDivisionNAI from '@/components/misc/WCDivisionNAI'
import WCLineActions from '@/components/misc/WCLineActions'
import WCStatusDialog from '@/components/misc/WCStatusDialog'
import WCPageSection from '@/components/misc/WCPageSection'
import WCDivisionTabs from '@/components/misc/WCDivisionTabs'

// Navs
import WCBurgerMenu from '@/components/nav/WCBurgerMenu'

// Forms
import WCFileField from '@/components/forms/WCFileField'


Vue.component('wc-loading', WCLoading)
Vue.component('wc-page-title', WCPageTitle)
Vue.component('wc-section-title', WCSectionTitle)
Vue.component('wc-full-page-loading', WCFullPageLoading)
Vue.component('wc-two-column-table', WCTwoColumnTable)
Vue.component('wc-save-cancel-buttons', WCSaveCancelButtons)

// Dialogs
Vue.component('wc-dialog', WCDialog)
Vue.component('wc-confirm', WCConfirmDialog)

Vue.component('wc-snackbar', WCSnackbar)
Vue.component('wc-archived', WCArchiveIcon)
Vue.component('wc-table-list', WCTableList)
Vue.component('wc-data-box', WCDataBox)
Vue.component('wc-toolbar-search', WCToolbarSearch)
Vue.component('wc-archive-button', WCArchiveButton)
Vue.component('wc-ratings', WCRatings)
Vue.component('wc-help', WCHelpDialog)
Vue.component('wc-help-icon', WCHelpToolbarIcon)
Vue.component('wc-show-archived-button', WCShowArchivedButton)
Vue.component('wc-division-nai', WCDivisionNAI)
Vue.component('wc-line-actions', WCLineActions)
Vue.component('wc-status-dialog', WCStatusDialog)
Vue.component('wc-page-section', WCPageSection)
Vue.component('wc-division-tabs', WCDivisionTabs)

// Nav
Vue.component('wc-burger-menu', WCBurgerMenu)

// Misc
Vue.component('wc-avatar', WCAvatar)
Vue.component('wc-mini-card', WCMiniCard)

// Pickers
Vue.component('wc-datepicker', WCMenuDatePicker)
Vue.component('wc-timepicker', WCMenuTimePicker)
Vue.component('wc-colorpicker', WCColorPicker)

// Forms
Vue.component('wc-file-field', WCFileField)

// Chips
Vue.component('wc-contact-role-chips', WCContactRoleChips)